import styled from 'styled-components';
import { BodyText, Image } from '@minerva-analytics/pantheon';
import {
  PEARL,
  WHITE,
  BLACK,
  HONEY,
  CLOUD,
  EXTRA_LARGE,
  LARGE,
  TABLET,
  MOBILE,
} from '../../theme';

const theme = {
  ghostAuthor: `
    text-transform: uppercase; 
    letter-spacing: 1.1px; 
    font-weight: 500; 
    font-family: 'Oswald', sans-serif; 
    font-size: 1rem; 
    line-height: 1.5rem; 
  `,
  ghostReadTime: `
    text-transform: uppercase; 
    letter-spacing: 1.3px; 
    font-size: 1.125rem;
    font-weight: 700; 
    font-family: 'Oswald', sans-serif;
    line-height: 1.6rem;
  `,
  ghostLink: `
    font-weight: 800;
  `,
  ghostBackTo: `
    :before { 
      content: " "; 
      border-bottom: solid 2px ${HONEY}; 
      width: 9.35rem; 
      bottom: 0; 
      position:absolute; 
      @media (max-width: ${MOBILE}){
        width: 8rem;
      }
    }; 
    margin: 0 0 1rem 0;
  `,
  ghostTitle: `
    font-size: 2.875rem;
    line-height: 3.4375rem;
  `,
  Image: `
    background-color: ${CLOUD};
  `,
};

const ArticleContainer = styled.div`
  background-color: ${PEARL};
  height: 100%;
  min-height: 100vh;
`;

const ShareButtons = styled.div`
  display: flex;
  flex-direction: row;
`;

const ShareContainer = styled.div`
  padding: 1rem 0 3rem 0;
  width: 46.875rem;
  margin: 0 auto;
  @media (max-width: ${TABLET}) {
    width: 85%;
  }
`;

const ShareText = styled(BodyText)`
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.5rem;
`;

const SubscribeText = styled(BodyText)`
  color: ${WHITE};
  margin-top: 0;
`;

const SubscribeHeader = styled.h2`
  color: ${WHITE};
  font-size: 2rem;
  font-family: 'Lato', sans-serif;
  font-weight: 800;
  @media (max-width: ${MOBILE}) {
    font-size: 1.75rem;
  }
`;

const SubscribeContainer = styled.div`
  background-color: ${BLACK};
  width: 100%;
  padding: 4rem 0;

  @media (max-width: ${TABLET}) {
    padding: 2rem 0;
  }
`;

const SubscribeWrapper = styled.div`
  width: 75%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;

  @media (max-width: ${EXTRA_LARGE}) {
    width: 80%;
  }

  @media (max-width: ${LARGE}) {
    width: 85%;
    flex-direction: column-reverse;
  }
`;

const SubscribeImage = styled(Image)`
  &&& {
    width: 300px;
    height: auto;

    @media (max-width: ${EXTRA_LARGE}) {
      width: 300px;
      height: auto;
    }

    @media (max-width: ${MOBILE}) {
      width: 250px;
      height: auto;
      margin: 0 auto;
    }
  }
`;

const SubscribeFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 3rem;

  @media (max-width: ${EXTRA_LARGE}) {
    max-width: 500px;
  }

  @media (max-width: ${LARGE}) {
    margin-left: 0;
    max-width: unset;
  }
`;

export {
  theme,
  ArticleContainer,
  ShareContainer,
  ShareButtons,
  ShareText,
  SubscribeContainer,
  SubscribeImage,
  SubscribeFormContainer,
  SubscribeWrapper,
  SubscribeHeader,
  SubscribeText,
};
